import { render, staticRenderFns } from "./BaseFilterGroupTable.vue?vue&type=template&id=6ccb967b"
import script from "./BaseFilterGroupTable.vue?vue&type=script&lang=js"
export * from "./BaseFilterGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports